import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import OrderRealizations from '../components/order-realizations/order-realizations';
import { useAppDispatch } from '../store';
import { setPaymentIds } from '../store/actions/operations-sign';
import { fetchIdOrder } from '../store/actions/order-detailed';
import {
  fetchRealizationPositions,
  initIssuePayment,
  setSigninIds,
  setSort,
} from '../store/actions/order-realization-detailed';
import { sortedPositions } from '../store/selectors/order-realization-detaild';
import { RootState } from '../types';
import { thunkResultHandler } from '../utils/thunks/thunkResultHandler';

const OrderDetailedPositionsContainer: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string; itemId: string }>();
  const state = useSelector((s: RootState) => s.realizationPositions);
  const accountInfo = useSelector((s: RootState) => s.auth.account);
  const orderInfo = useSelector((s: RootState) => s.orderDetailed.data.order);
  const realizationInfo = useSelector(
    (s: RootState) => s.realizationPositions.data.info
  );
  const balance = useSelector(
    (s: RootState) => s.balance.data.info?.simpleTokenValue
  );
  const sortedPos = useSelector(sortedPositions);

  const getPropsDetailed = sortedPos.map((item) => ({
    title: item.name,
    count: item.count,
    sum: item.price,
  }));

  useEffect(() => {
    dispatch(fetchIdOrder({ id: parseInt(params.id, 10) }));
  }, []);

  useEffect(() => {
    dispatch(
      fetchRealizationPositions({
        id: parseInt(params.id, 10),
        itemId: parseInt(params.itemId, 10),
      })
    );
  }, []);

  const submitAndGoSign = () => {
    const routerCb = () =>
      history.push(`/orders/${params.id}/realizations/sign`);
    dispatch(setPaymentIds([parseInt(params.itemId, 10)]));
    if (
      realizationInfo.itemStatus === 'UCP_PAYMENT_REQUIRED' &&
      realizationInfo.issuingInfoId
    ) {
      dispatch(setSigninIds([realizationInfo.issuingInfoId]));
      dispatch(
        initIssuePayment({ ids: [realizationInfo.issuingInfoId] })
      ).then((action) => thunkResultHandler(action, routerCb));
    } else {
      dispatch(setSigninIds([parseInt(params.itemId, 10)]));
      history.push(`/orders/${params.id}/selectPayment`, {
        id: parseInt(params.id, 10),
      });
    }
  };

  const onClose = () => {
    history.push('/orders');
  };

  const onSpecDownload = () => {};

  const checkBalanceError = () =>
    (balance || 0) < (realizationInfo?.sum || 0) &&
    realizationInfo.itemStatus === 'UCP_PAYMENT_REQUIRED';

  return (
    <OrderRealizations
      tokenId={realizationInfo?.tokenId}
      initiatorId={orderInfo?.initiatorId}
      isError={!!checkBalanceError()}
      onClose={onClose}
      onToggleSort={(name, direction) => {
        dispatch(setSort({ name, direction }));
      }}
      directions={{
        count: state.data.sorts.count.direction,
        sum: state.data.sorts.sum.direction,
      }}
      isInitiator={accountInfo.id === orderInfo?.initiatorId}
      onSubmit={submitAndGoSign}
      onSpecDownload={onSpecDownload}
      sum={realizationInfo.sum}
      status={state.data.info.itemStatus}
      data={getPropsDetailed ?? []}
      orderRefNumber={realizationInfo?.refNumber ?? ''}
    />
  );
};

export default OrderDetailedPositionsContainer;
